export default __webpack_public_path__ + "static/media/add-from-card-icon.13809985.svg";